import { LeadsService } from "./implementations/leads.service";

export default defineNuxtPlugin((nuxtApp) => {
  const leads = new LeadsService(
    nuxtApp.$axios,
    nuxtApp.$config.public.sgApiUrl
  );

  return {
    provide: {
      leads: leads,
    },
  };
});

